"use strict";

import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React, {
    useEffect,
    useState,
    useCallback,
    useRef,
    useContext,
} from "react";
import classes from "../../Assets/Styles/Translation.module.css";
import { formatTime, timeStringToSeconds } from "../../utils/generalFunctions";
import {
  ensureProjectFinalLanguageTranslations,
  findTranslationByLanguageCode,
  getDefaultVoiceIdForEmotion,
  getSpeakerDisplayName,
} from "../../features/projectWork";
import Loader from "../../Components/Loader";
import axios from "axios";
import { Store } from "../../Store";
import {
    UPDATE_ONE_SPEECH,
    GET_CHARACTERS_FOR_PROJECT,
    // UPLOAD_TRANSLATOR_VOICE,
    GET_SPEECH_FOR_PROJECT_BY_PAGE,
    GET_SPEECH_POSITION_AROUND_TIME,
    GET_ALL_SPEECHES,
} from "../../ApiEndpoints";
import { ToastContainer, toast } from "react-toastify";
import { useMediaQuery } from "@mui/material";
import ReactAudioPlayer from "react-audio-player";
import UnifiedVideoPlayer from "../../Components/Players/UnifiedVideoPlayer";
import { useParams } from "react-router-dom";
import TaskButton from "../../Components/Buttons/TaskButton";
import { saveAs } from "file-saver"; // npm install file-saver

// import ReactRecorder from "../../Components/VoiceRecording/ReactRecorder";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import MicNoneIcon from "@mui/icons-material/MicNone";
// import TuneIcon from "@mui/icons-material/Tune";

const TranslatorScreen = () => {
  const params = useParams();
  const { language: languageCode } = params;
  const screenIsOver1200px = useMediaQuery("(min-width: 1200px)");
  const { state } = useContext(Store);
  const { projectFile, userInfo } = state;
  const [characters, setCharacters] = useState([]);
  const [audioData, setAudioData] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [seekTime, setSeekTime] = useState(0);
  const [seekTimeIndex, setSeekTimeIndex] = useState(0);
  const [scrollableItem, setScrollableItem] = useState(0);
  const [scrollableItemLastUpdated, setScrollableItemLastUpdated] = useState(0);
  const [audioLoader, setAudioLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [pausePlay, setPausePlay] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);

  // const [newAudioRecorder, setNewAudioRecorder] = useState(null);

  const numberOfDialogues = projectFile?.numberOfDialogues || 0;

  const timeoutIdRef = useRef(null);

  // pagination items
  const [pageButtonActivity, setPageButtonActivity] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [goToPageNumber, setGoToPageNumber] = useState();
  const itemsPerPage = 10;
  const totalPages = Math.ceil(numberOfDialogues / itemsPerPage);

  const containerRef = useRef(null);

  const checkTimeInRange = useCallback(
    (time) => {
      if (!audioData) {
        return;
      }

      const itemInTimeRange = audioData.find(
        (item) => time >= item.start && time < item.end
      );

      if (itemInTimeRange && itemInTimeRange.id !== scrollableItemLastUpdated) {
        setScrollableItemLastUpdated(itemInTimeRange.id);
        setScrollableItem(itemInTimeRange.id);
      }
    },
    [audioData, scrollableItemLastUpdated]
  );

  useEffect(() => {
    checkTimeInRange(currentTime);
  }, [currentTime, checkTimeInRange]);

  const scrollToItem = (index) => {
    if (containerRef.current) {
      const item = containerRef.current.children[index];
      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  useEffect(() => {
    if (pausePlay) {
      if (screenIsOver1200px) {
        scrollToItem(scrollableItem - 1);
      }
    }
  }, [scrollableItem, pausePlay, screenIsOver1200px]);

  const displayAudioTime = useCallback((data) => {
    setCurrentTime(data);
  }, []);

  // function findNewestUrlCreated(objects) {
  //   if (objects === undefined) {
  //     return "";
  //   }

  //   if (objects.length === 0) {
  //     return null;
  //   }

  //   // Sort the array of objects based on creation time in descending order
  //   const sortedObjects = objects.sort((a, b) => {
  //     const dateA = new Date(a.creationTime);
  //     const dateB = new Date(b.creationTime);
  //     return dateB - dateA;
  //   });

  //   // Return the object with the newest creation time (first element after sorting)
  //   return sortedObjects[0].url;
  // }

  function findDisplayName(speaker) {
    return getSpeakerDisplayName(characters, speaker);
  }

  const findDefaultEmotion = useCallback(
    (speaker, originalAudioEmotion) => {
      return getDefaultVoiceIdForEmotion(
        projectFile?.characters,
        speaker,
        originalAudioEmotion
      );
    },
    [projectFile?.characters]
  );

  const checkLanguage = useCallback(
    (translations = []) => {
      return ensureProjectFinalLanguageTranslations(
        translations,
        projectFile?.finalLang
      );
    },
    [projectFile?.finalLang]
  );

const findTransObjectsbyLangCode = (array = []) => {
    return findTranslationByLanguageCode(array, languageCode);
};

  //+ Start time api for dialogue
  function handleStartTimeChange(e, index) {
    const newTime = timeStringToSeconds(e.target.value);
    if (!newTime) {
      return;
    }

    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      start: newTime,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 2300);
  }
  //+ End time api for dialogue
  function handleEndTimeChange(e, index) {
    const newTime = timeStringToSeconds(e.target.value);
    if (!newTime) {
      return;
    }

    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      end: newTime,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 2300);
  }

  //api for handling notes change
  function handleNoteChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudioNote: e.target.value,
          };
        } else {
          return prev;
        }
      }
    );
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);

    setAudioData(updatedData);
  }

  //api for handling voice recording
  // function startRecordingVoice(index) {
  //   const updatedData = [...audioData];
  //   updatedData[index] = {
  //     ...updatedData[index],
  //     record: true,
  //     recordedBlob: false,
  //   };

  //   updatedData[index].translations = updatedData[index].translations.map(
  //     (prev) => {
  //       if (prev.languageCode === languageCode) {
  //         return {
  //           ...prev,
  //           translatedRecording: false,
  //         };
  //       } else {
  //         return prev;
  //       }
  //     }
  //   );
  //   setAudioData(updatedData);
  // }

  //api for handling original text
  function handleTextChange(e, index) {
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      text: e.target.value,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  //api for handling translation text
  function handleTranslationChange(e, index) {
    const updatedData = [...audioData];
    // updatedData[index].translations = {
    //   ...updatedData[index].translations,
    //   translatedText: e.target.value,
    // };

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedText: e.target.value,
          };
        } else {
          return prev;
        }
      }
    );

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  //api voice audio
  // const handleRecordedAudio = async (data) => {
  //   setAudioLoader(true);
  //   const updatedData = [...audioData];
  //   updatedData[data.id] = {
  //     ...updatedData[data.id],
  //     record: false,
  //     recordedBlob: newAudioRecorder.blobURL,
  //   };

  //   const formData = new FormData();

  //   formData.append(
  //     "file",
  //     newAudioRecorder.blob,
  //     data.speaker + data.start + "_" + data.end
  //   );

  //   formData.append("speaker", data.speaker);
  //   formData.append("start", data.start);
  //   formData.append("end", data.end);

  //   try {
  //     const response = await axios.post(UPLOAD_TRANSLATOR_VOICE, formData);

  //     updatedData[data.id].translations = updatedData[data.id].translations.map(
  //       (prev) => {
  //         if (prev.languageCode === languageCode) {
  //           return {
  //             ...prev,
  //             translatedRecording: response.data.url,
  //           };
  //         } else {
  //           return prev;
  //         }
  //       }
  //     );

  //     try {
  //       const response = await axios.post(UPDATE_ONE_SPEECH, {
  //         projectId: projectFile.id,
  //         dialogue: updatedData[data.id],
  //       });
  //       setNewAudioRecorder(null);
  //       setAudioData(updatedData);

  //       toast.success("Voice recording has been uploaded");

  //       setAudioLoader(false);
  //     } catch (error) {
  //       console.log(error);
  //       setAudioLoader(false);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     setAudioLoader(false);
  //   }
  // };

  //+ face api for dialogue
  const handleKeepOriginalText = async (index) => {
    setAudioLoader(true);
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      keepOriginalText: !updatedData[index].keepOriginalText,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  //api for handling notes change
  function handleTranslatedSentenceChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedText: e.target.value,
          };
        } else {
          return prev;
        }
      }
    );
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);

    setAudioData(updatedData);
  }

  const nextPrevPageAPI = async (action) => {
    setPageButtonActivity(true);
    if (pageNumber === 1 && action === "previous") {
      return;
    }
    try {
      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: action,
        pageName: "translate",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        dialogues.forEach((dia, index) => {
          dia.id = index;
          dia.tempTransEmotion = findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          );
          dia.translatedAudioDurationTemp = null;
          dia.record = false;
          dia.translations = checkLanguage(dia.translations);
          dia.filterShow = true;
        });

        setAudioData(dialogues);
        if (action === "next") {
          setPageNumber(Number(pageNumber) + 1);
        } else if (action === "previous") {
          setPageNumber(Number(pageNumber) - 1);
        }
        setPageButtonActivity(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  const goToPageAPI = async (number) => {
    setLoader(true);

    try {
      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: number,
        pageName: "translate",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        dialogues.forEach((dia, index) => {
          dia.id = index;
          dia.tempTransEmotion = findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          );
          dia.translatedAudioDurationTemp = null;
          dia.record = false;
          dia.translations = checkLanguage(dia.translations);
          dia.filterShow = true;
        });

        setAudioData(dialogues);
        setGoToPageNumber("");
        setPageNumber(number);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  //apis - get characters
  useEffect(() => {
    if (!projectFile?.id) {
      return;
    }
    const fetchData = async () => {
      try {
        const response = await axios.post(GET_CHARACTERS_FOR_PROJECT, {
          projectId: projectFile.id,
        });

        setCharacters(response.data.characters);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [projectFile.id]);

  //apis - dialogue
  useEffect(() => {
    if (!projectFile?.id || !userInfo?.id) {
      return;
    }
    const fetchData = async () => {
      setLoader(true);
      try {
        const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
          userId: userInfo.id,
          projectId: projectFile.id,
          action: "first",
          Current: null,
          pageName: "translate",
        });

        const dialogues = await response.data.projectsArray;

        dialogues.forEach((dia, index) => {
          dia.id = index;
          dia.tempTransEmotion = findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          );
          dia.translatedAudioDurationTemp = null;
          dia.record = false;
          dia.translations = checkLanguage(dia.translations);
          dia.filterShow = true;
        });

        setAudioData(dialogues);
        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      }
    };
    fetchData();
  }, [projectFile.id, userInfo.id, checkLanguage, findDefaultEmotion]);

  const handleTimeSync = async (time) => {
    try {
      setLoader(true);
      const positionResponse = await axios.post(GET_SPEECH_POSITION_AROUND_TIME, {
        projectId: projectFile.id,
        time: time
      });

      const number = Math.ceil(positionResponse.data.firstPosition / 10);

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: number,
        pageName: "translate",  // Changed from 'transcribe' to 'translate'
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;

        dialogues.forEach((dia, index) => {
          dia.id = index;
          dia.tempTransEmotion = findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          );
          dia.translatedAudioDurationTemp = null;
          dia.record = false;
          dia.translations = checkLanguage(dia.translations);
          dia.filterShow = true;
        });

        setAudioData(dialogues);
        setGoToPageNumber("");
        setPageNumber(number);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error syncing to current time position");
    }
  };

  const handleExportCSV = async () => {
    try {
      setExportLoader(true); // Start loading

      const { data } = await axios.post(GET_ALL_SPEECHES, {
        projectId: projectFile.id,
        languageCode,
      });

      const sortedData = data.projectsArray.sort((a, b) => a.start - b.start);

      const rows = [
        ["Speaker", "Start", "End", "Original Text", "Keep Original Text", "Language Code", "Translated Text", "Notes"]
      ];

      sortedData.forEach(item => {
        rows.push([
          findDisplayName(item.speaker),
          formatTime(item.start),
          formatTime(item.end),
          item.text?.replace(/\n/g, " ") || "",
          item.keepOriginalText,
          item.languageCode,
          item.translatedText?.replace(/\n/g, " ") || "",
          item.note?.replace(/\n/g, " ") || ""
        ]);
      });

      const csvContent = rows.map(row => row.map(cell => `"${cell}"`).join(",")).join("\n");
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const fileName = `${projectFile.name} - ${languageCode.toUpperCase()}.csv`;
      saveAs(blob, fileName);

      setExportLoader(false); // Stop loading
    } catch (err) {
      console.error("CSV Export Error:", err);
      toast.error("Failed to export CSV");
      setExportLoader(false);
    }
  };


  if (!projectFile?.id) {
    return <Loader />;
  }

  return (
    <Grid
      item
      container
      justifyContent="center"
      marginTop={4}
      style={{ fontFamily: "var(--font-body)" }}
    >
      <ToastContainer position="top-center" />
      <Loader Load={audioLoader} />
      <Loader Load={loader} />
      <Loader Load={exportLoader} />

      <Grid item container xs={11.3} direction="column">
        <Grid item container direction="row">
          
          <UnifiedVideoPlayer
            source={projectFile.videoUrl}
            seekTime={seekTime}
            displayAudioTime={displayAudioTime}
            seekTimeIndex={seekTimeIndex}
            setPausePlay={setPausePlay}
            layout="horizontal"
            dualAudio={false}
            enableScroll={true}
            customClasses={{
              container: classes["AudioOutPutHorizontal"],
              containerStyles: {},
              videoContainer: classes["AudioOutPutVideoHorizontal"],
              controlsContainer: classes["AudioOutPutController"],
              timeDisplay: classes["AudioOutPutShownTime"],
              selector: classes["AudioOutPutShowTimeOptionBox"],
            }}
            onTimeSync={handleTimeSync}
            onExportCSV={handleExportCSV}
          />

            <Grid
              item
              container
              xs={12}
              className={classes["AudioWorkPlace"]}
              direction="column"
              height="1520px"
              marginTop={2}
              marginBottom={4}
              ref={containerRef}
            >
              {/* Header row */}
              <Grid
                item
                container
                className={classes["AudioWorkPlaceBoxes"]}
                direction="row"
                alignItems="center"
                columnSpacing={2}
                sx={{
                  background: "var(--color-table-header-bg)",
                  color: "var(--color-table-header-text)",
                  fontWeight: 600,
                }}
              >
                <Grid item xs={1} />
                <Grid item xs={3} container justifyContent="center">
                  <Grid item>Original</Grid>
                </Grid>

                <Grid item xs={3} container justifyContent="center">
                  <Grid item>Translation</Grid>
                </Grid>

                <Grid item xs={2} container justifyContent="center">
                  <Grid item>Use Original Text</Grid>
                </Grid>
                <Grid item xs={3} container justifyContent="center">
                  <Grid item>Notes</Grid>
                </Grid>
              </Grid>

              {audioData ? (
                <>
                  {audioData.map((data, index) => (
                    <Grid
                      item
                      container
                      className={classes["AudioWorkPlaceBoxes"]}
                      direction="row"
                      marginBottom={0.5}
                      onClick={() => {
                        setSeekTime(data.start);
                        setSeekTimeIndex((prev) => (prev === 1 ? 2 : 1));
                        scrollToItem(data.id);
                      }}
                      columnSpacing={2}
                      sx={{ cursor: "pointer" }}
                      key={index}
                    >
                      <Grid
                        xs={1}
                        item
                        container
                        direction="row"
                        sx={{
                          borderTopLeftRadius: "var(--radius-md)",
                          borderBottomLeftRadius: "var(--radius-md)",
                        }}
                        className={classes["speaker-box"]}
                        alignContent="center"
                        justifyContent="center"
                        gap={1.5}
                      >
                        <Grid
                          item
                          sx={{
                            fontSize: "var(--font-size-normal)",
                            maxWidth: "100px",
                            minWidth: "55px",
                          }}
                        >
                          {data.speaker ? (
                            findDisplayName(data.speaker)
                          ) : (
                            <Grid fontSize="var(--font-size-normal)">NO SPEAKER</Grid>
                          )}
                        </Grid>

                        <Grid item>
                          <textarea
                            disabled={true}
                            className={
                              classes["AudioWorkPlaceTimelineEditTranslation"]
                            }
                            value={formatTime(data.start)}
                            type="text"
                            onChange={(e) => handleStartTimeChange(e, data.id)}
                          ></textarea>
                        </Grid>
                        <Grid item>
                          <textarea
                            disabled={true}
                            className={
                              classes["AudioWorkPlaceTimelineEditTranslation"]
                            }
                            value={formatTime(data.end)}
                            type="text"
                            onChange={(e) => handleEndTimeChange(e, data.id)}
                          ></textarea>
                        </Grid>
                      </Grid>

                      <Grid
                        xs={3}
                        item
                        container
                        direction="column"
                        gap={1.5}
                      >
                        <Grid item>
                          <ReactAudioPlayer
                            style={{
                              width: "85%",
                              height: "25px",
                              borderRadius: " var(--radius-md)",
                            }}
                            src={data.originalAudio}
                            controls
                          />
                        </Grid>

                        <Grid item>
                          <textarea
                            className={classes["AudioWorkTextEditInput"]}
                            style={{
                              color:
                                currentTime >= data.start &&
                                currentTime < data.end
                                  ? "red"
                                  : undefined,
                            }}
                            value={data.text}
                            type="text"
                            onChange={(e) => handleTextChange(e, data.id)}
                          ></textarea>
                        </Grid>
                      </Grid>
                      <Grid
                        xs={3}
                        item
                        container
                        direction="row"
                      >
                        {data.keepOriginalText ? (
                              <></>
                            ) : (
                              <>
                                <Grid
                                  item
                                  container
                                  direction="column"
                                  gap={1.5}
                                >
                                  <Grid item>
                                    <Grid
                                      item
                                      fontSize="var(--font-size-normal)"
                                      container
                                      direction="row"
                                      gap={1}
                                    >
                                      <Grid item>
                                        <select
                                          className={
                                            classes[
                                              "AudioWorkSenetenceSelector"
                                            ]
                                          }
                                          style={{ width: "200px" }}
                                          value={
                                            findTransObjectsbyLangCode(
                                              data.translations
                                            ).translatedText
                                          }
                                          onChange={(e) => {
                                            handleTranslatedSentenceChange(
                                              e,
                                              data.id
                                            );
                                          }}
                                          disabled={true}
                                        >
                                          <option value="">
                                            Alternative sentences
                                          </option>

                                          {findTransObjectsbyLangCode(
                                            data?.translations
                                          )?.audioAttempts?.map(
                                            (sentence, index) => (
                                              <option
                                                key={index}
                                                value={
                                                  sentence.translatedText
                                                }
                                              >
                                                {sentence.translatedText}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item>
                                    <textarea
                                      className={
                                        classes["AudioWorkTextEditInput"]
                                      }
                                      style={{
                                        color:
                                          currentTime >= data.start &&
                                          currentTime < data.end
                                            ? "red"
                                            : undefined,
                                      }}
                                      value={
                                        findTransObjectsbyLangCode(
                                          data.translations
                                        ).translatedText
                                      }
                                      type="text"
                                      onChange={(e) =>
                                        handleTranslationChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                          </Grid>
                          <Grid xs={2} item>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={data.keepOriginalText}
                                />
                              }
                              label="Use original text"
                              labelPlacement="end"
                              sx={{
                                marginTop: 1.5,
                                marginRight: 1.5,
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "var(--font-size-normal)",
                                  fontWeight: 500,
                                },
                              }}
                              onClick={() =>
                                handleKeepOriginalText(data.id)
                              }
                            />
                          </Grid>

                          <Grid xs={3} item container direction="column">
                            <Grid item marginTop={2}>
                              <textarea
                                className={
                                  classes["AudioWorkNoteEditInput"]
                                }
                                value={
                                  findTransObjectsbyLangCode(
                                    data.translations
                                  ).translatedAudioNote
                                    ? findTransObjectsbyLangCode(
                                        data.translations
                                      ).translatedAudioNote
                                    : ""
                                }
                                placeholder="add note here"
                                type="text"
                                onChange={(e) =>
                                  handleNoteChange(e, data.id)
                                }
                              ></textarea>
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                  </Grid>
              <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              marginTop={3}
            >
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <Grid item>
                  <TaskButton
                    onClick={() => nextPrevPageAPI("previous")}
                    width="80px"
                    disabled={Number(pageNumber) === 1 || pageButtonActivity}
                  >
                    Previous
                  </TaskButton>
                </Grid>

                <Grid item>
                  <span>
                    Page {pageNumber} of {totalPages}
                  </span>
                </Grid>

                <Grid item>
                  <TaskButton
                    width="80px"
                    onClick={() => nextPrevPageAPI("next")}
                    disabled={
                      Number(pageNumber) === totalPages || pageButtonActivity
                    }
                  >
                    Next
                  </TaskButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              gap={4}
              marginTop={1}
            >
              <Grid item>
                <input
                  type="text"
                  style={{ width: "40px" }}
                  value={goToPageNumber}
                  // placeholder="Enter the page number "
                  onChange={(e) => {
                    setGoToPageNumber(e.target.value >= 1 ? e.target.value : 1);
                  }}
                />
              </Grid>
              <Grid item>
                <TaskButton
                  onClick={() => goToPageAPI(goToPageNumber)}
                  width="80px"
                >
                  Go
                </TaskButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

export default TranslatorScreen;
